import { render, staticRenderFns } from "./VerticalInputs.vue?vue&type=template&id=fcd6d266&scoped=true"
import script from "./VerticalInputs.vue?vue&type=script&lang=js"
export * from "./VerticalInputs.vue?vue&type=script&lang=js"
import style0 from "./VerticalInputs.vue?vue&type=style&index=0&id=fcd6d266&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcd6d266",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fcd6d266')) {
      api.createRecord('fcd6d266', component.options)
    } else {
      api.reload('fcd6d266', component.options)
    }
    module.hot.accept("./VerticalInputs.vue?vue&type=template&id=fcd6d266&scoped=true", function () {
      api.rerender('fcd6d266', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/questionConfig/subViews/detail/components/VerticalInputs.vue"
export default component.exports